import type { Customer, Individual } from '../../../services/schemas/customerServiceSchemas';

export type IndividualCustomer = Customer & { type: 'INDIVIDUAL'; info: Individual };
export const isIndividualCustomer = (customer?: Customer): customer is IndividualCustomer =>
  customer?.type === 'INDIVIDUAL' && customer.info?.type === 'INDIVIDUAL';
export const individualName = (customer: IndividualCustomer) =>
  [customer.info.firstName, customer.info.lastName].filter(Boolean).join(' ') || customer.customerNumber || 'Individual customer';
export const restrictedIndividual = (status?: string) => ['INACTIVE', 'SUSPENDED', 'BLACKLISTED'].includes(status || '');
export const individualStatusLabel = (status?: string) => status === 'SUSPENDED' ? 'BLACKLISTED' : status || 'UNKNOWN';
export const individualStatusVariant = (status?: string) => status === 'ACTIVE' ? 'success' : status === 'INACTIVE' ? 'danger' : 'warning';
export function customerError(error: unknown, fallback = 'Unable to save the customer. Please try again.'): string {
  const candidate = error as { response?: { data?: { message?: string; detail?: string } }; message?: string };
  return candidate?.response?.data?.message || candidate?.response?.data?.detail || candidate?.message || fallback;
}
